import { useCallback, useState } from "react";
import { BaseButton } from "@/src/component/base/BaseButton";

import { DialogWithExit } from "@/src/component/base/DialogWithExit";
import { DeepSkyType } from "@/src/type";

import styles from "./PreapprovalDialog.module.scss";
import { TextModule } from "../../../../../../partial/__module__";
interface PreapprovalDialogProps {
  unit: DeepSkyType.AssetType.PropertyInventory.Unit;
  ollUrl: string;
  showPreapprovalDialog: boolean;
  handlePreApproval: () => void;
}
const questions = ["Will you be the only applicant?", "Do you have a social security number?", "Do you currently live in the United States?"];

function PreapprovalDialog({ unit, ollUrl, showPreapprovalDialog, handlePreApproval }: PreapprovalDialogProps) {
  const [questionIndex, setQuestionIndex] = useState(0);

  const handleYes = useCallback(() => {
    if (questionIndex === questions.length - 1) {
      window.open(`https://home.flow.life/application?unit=${unit.name}&unit-fid=${unit.fid}&ollurl=${encodeURIComponent(ollUrl)}`, "_blank");
      setQuestionIndex(0);
      handlePreApproval();
    } else {
      setQuestionIndex(questionIndex + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionIndex, unit.name, unit.fid, ollUrl]);

  const handleBackButtonClick = useCallback(() => {
    setQuestionIndex(questionIndex - 1);
  }, [questionIndex]);

  const handleNo = () => {
    setQuestionIndex(0);
    window.open(ollUrl, "_blank");
    handlePreApproval();
  };

  /**
   * get the table row cta, default to known apply to url
   */

  return (
    <DialogWithExit
      dialogProps={{
        open: showPreapprovalDialog,
        onClose: handlePreApproval,
      }}
      dialogContentProps={{
        className: styles.dialogContent,
      }}
      onExit={handlePreApproval}
    >
      <div
        hidden={!questionIndex}
        role="button"
        onClick={handleBackButtonClick}
        style={{}}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M20.0005 24L12.0005 16L20.0005 8"
            stroke="#1A1A1A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div
        className="flex flex-col"
        style={{ maxWidth: "358px", gap: "32px" }}
      >
        <TextModule
          text={{ text: questions[questionIndex], tag: "body1" }}
          className={styles.question}
        />
        <div className={styles.buttonContainer}>
          <BaseButton
            variant="outlined"
            className={styles.button}
            onClick={handleYes}
          >
            Yes
          </BaseButton>
          <BaseButton
            variant="outlined"
            className={styles.button}
            onClick={handleNo}
          >
            No
          </BaseButton>
        </div>
      </div>
    </DialogWithExit>
  );
}

export default PreapprovalDialog;
